import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const MyEvents = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomStudentMyEvents" */ 'modules/virtualClassrooms/student/Events/pages/MyEvents'
    )
)

export const EventLibrary = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomStudentEventLibrary" */ 'modules/virtualClassrooms/student/Events/pages/EventLibrary'
    )
)

export const EventsCategory = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomStudentEventsCategory" */ 'modules/virtualClassrooms/student/Events/pages/EventsCategory'
    )
)

const EventsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.my} component={MyEvents} />
      <Route exact path={routes.library} component={EventLibrary} />
      <Route exact path={`${routes.category}/:categoryId`} component={EventsCategory} />
      <Redirect path='*' to={routes.my} />
    </Switch>
  </Suspense>
)

export default EventsRouting
